import * as graphql from './graphql-service';
import * as site from './siteService';
import * as map from './mapService';
import * as gsCta from './gsCtaService';
import * as qaContainer from './qaContainerService';
import * as form from './form-service';
import scriptLoaderService from './scriptLoaderService';
import * as country from './country-service';
const services = { graphql, site, map, scriptLoaderService, gsCta, qaContainer, form, country };
export default services;
